import {
  CATALOG_TAG_DETAIL_SET_DATA,
  CATALOG_TAG_DETAIL_RESET_DATA,
} from 'rebook/apps/catalog/constants';


const initialState = {
  tag: null,
  books: null,
  paginateBy: 24,
  pageNumber: 1,
  lastPageNumber: 0,
  orderBy: 'popular',
  totalBookCount: null,
  subscriptionId: null,
  bookType: null,
};

export default function tagDetail(state = initialState, action) {
  switch (action.type) {
    case CATALOG_TAG_DETAIL_SET_DATA:
      return {
        ...state,
        ...action.payload,
      };
    case CATALOG_TAG_DETAIL_RESET_DATA:
      return initialState;
    default:
      return state;
  }
}
